import { IsNotEmpty, IsEnum } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { EmpLeaveDTO } from "./emp-leaves.dto";

export class EmployeeLeavesCreateDTO {
    @ApiProperty()
    @IsNotEmpty()
    createdUser: string;
    @ApiProperty()
    @IsNotEmpty()
    dateTime: Date;
    @ApiProperty({ type: () => [EmpLeaveDTO] })
    @IsNotEmpty()
    empLeaveData:EmpLeaveDTO[]
}